// src/features/uploadSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    progress: 0,
    error: null,
  },
  reducers: {
    setUploadProgress: (state, action) => {
      state.progress = action.payload;
    },
    setUploadError: (state, action) => {
      state.error = action.payload;
    },
    clearUploadState: (state) => {
      state.progress = 0;
      state.error = null;
    },
  },
});

export const { setUploadProgress, setUploadError, clearUploadState } = uploadSlice.actions;
export default uploadSlice.reducer;